export default "__VITE_ASSET__D_F0k86Z__"